/* eslint-disable complexity */
import { createAutoDeleteFolder, isFileForOpenInEditor, openEditor } from 'reactApp/appHelpers/appHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { attachesOpenViewer } from 'reactApp/modules/attaches/attaches.actions';
import { isFolder } from 'reactApp/modules/file/utils';
import { changeHomeHistory } from 'reactApp/modules/home/home.actions';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { trashbinRestoreRequest } from 'reactApp/modules/trashbin/trashbin.module';
import { openUserQuotaItemView } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { openViewer } from 'reactApp/modules/viewer/viewer.module';
import { createCreateNewMenu } from 'reactApp/ui/ContextMenu/createContextMenuList';
import { renderContextMenu } from 'reactApp/ui/ContextMenu/createContextMenuToolkit';
import { logHandler } from 'reactApp/ui/Datalist/DataList.helpers';
import { DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { sendDatalistGa } from 'reactApp/utils/datalistGa';
import { sendGa } from 'reactApp/utils/ga';
import { getEncodePath, getHomeFolderPath } from 'reactApp/utils/urlHelper';

const getItemId = (item) => {
    const { isPublic, isAlbums } = getStorage(item.storage);

    if (isAlbums) {
        return item.id;
    }

    if (isPublic) {
        return item.weblink;
    }

    return item.home || item.id;
};

export const onItemClick = ({ id, item, goTo, dispatch, storage, viewMode, attachType, attachFolderId }) => {
    const isFile = !isFolder(item);
    const {
        isSharedIncoming,
        isTrashBin,
        isHome,
        isSearch,
        isSharedLinks,
        isSharedAutodelete,
        isFavorites,
        isQuotaCleaner,
        isAttaches
    } = getStorage(item.storage);
    const reloadPageToFolderHome = (isSearch || isSharedLinks || isSharedIncoming) && item.isFolder;
    const openFolderHome = (isFavorites || isSharedAutodelete) && item.isFolder;
    const isHomeFolder = isHome && !isFile;
    const isOpenViewer = !item.isFolder;
    const inviteToken = isSharedIncoming && item.inviteToken;

    sendDatalistGa('open', `${item.isFolder ? 'folder' : 'file'}${viewMode}`);

    if (isQuotaCleaner) {
        dispatch(openUserQuotaItemView({ id: item.id }));
        return;
    }

    if (inviteToken) {
        toolbarActions.mount();
    } else if (isTrashBin) {
        dispatch(
            trashbinRestoreRequest({
                ids: [item.id],
                from: 'double-click',
            })
        );
    } else if (openFolderHome) {
        dispatch(historyPush({ id: getHomeFolderPath(item.home) }));
    } else if (reloadPageToFolderHome) {
        // TODO: routing
        location.href = getHomeFolderPath(getEncodePath(item.home));
    } else if (isFileForOpenInEditor(item)) {
        openEditor(item);
    } else if (isHomeFolder) {
        dispatch(changeHomeHistory({ id }));
    } else if (isOpenViewer) {
        const data = {
            itemId: getItemId(item),
            itemStorage: storage || null,
            gaSuffix: '',
            itemIds: [],
        };
        sendGa('datalist', 'open-viewer', viewMode);

        if (isAttaches) {
            dispatch(attachesOpenViewer({ id: item.id, attachType, folderId: attachFolderId }));
        } else {
            dispatch(openViewer(data));
        }
    } else {
        goTo({ id, item });
    }
};

export const onClickCreateNew = (e, { gaSuffix, storage }) => {
    const { isSharedLinks, isSharedAutodelete } = getStorage(storage);

    e.preventDefault();
    e.stopPropagation();

    if (isSharedAutodelete) {
        createAutoDeleteFolder();
        return;
    }

    if (isSharedLinks) {
        logHandler({
            radarName: 'createnew_shared_click',
        });
        toolbarActions.create('folder', 'datalist', true, 'shared');

        return;
    }

    logHandler({
        radarName: 'createnew_click',
    });
    renderContextMenu({
        posX: e.pageX,
        posY: e.pageY,
        menuItems: createCreateNewMenu({ createFrom: 'datalist' }),
        theme: DropdownTheme.medium,
        gaSuffix: `ctx_create${gaSuffix ? `_${gaSuffix}` : ''}`,
        storage,
    });
};
